module.exports = __webpack_public_path__ + "static/img/u86.84ae2af3.png";